/**
 * Claves de persistencia de la sesión de carga de animales.
 *
 * Compartidas entre web (localStorage) y mobile (AsyncStorage vía @shared).
 * La sesión de carga NO se comparte entre empresas: junto al código de sesión
 * se persiste la empresa activa (`EMPRESA_ID`) para poder descartar una sesión
 * restaurada que pertenezca a otra empresa.
 */
export const CARGA_SESSION_STORAGE_KEYS = {
  SESSION_CODE: 'animal_session_code',
  ACTIVE_FIELDS: 'animal_session_active_fields',
  SESSION_ANIMALS: 'animal_session_animals',
  LAST_RAZA: 'animal_session_last_raza',
  LAST_RENSPA: 'animal_session_last_renspa',
  LAST_CATEGORIA: 'animal_session_last_categoria',
  LAST_UBICACION: 'animal_session_last_ubicacion',
  EMPRESA_ID: 'animal_session_empresa_id',
} as const;
